var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-topic-list" },
    _vm._l(_vm.topicList, function (topic) {
      return _c(
        "div",
        { key: topic.topicId },
        [_c("a-topic", { attrs: { topic: topic } })],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }